import React, {createContext, useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import HideAppBar from "../../../widgets/header/HideAppBar";
import Grid from "@mui/material/Grid";
import {
	Backdrop,
	Button,
	CircularProgress,
	Container,
	DialogActions,
	DialogContentText,
	Fab, FormControl, InputLabel, MenuItem, Select, TextField,
	Tooltip
} from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {
	getAllMonitoraggiByQuarantena,
	getFocolaioById,
	getQuarantenaHistory, modifyAliasFocolaio, updateFocolaio
} from "../../../../services/QuaranteneServices";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import AnagraficaAccordion from "./AnagraficaAccordion";
import {AnagraficaContext, AppContext} from "../../../../App";
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import QuarantenaInfoCard from "../../quarantene/detail/QuarantenaInfoCard";
import HistoryCard from "../../quarantene/detail/HistoryCard";
import PrenotaTamponeCard from "../../ticket/details/PrenotaTamponeCard";
import MonitoraggiCard from "../../quarantene/monitoraggi/detail/MonitoraggiCard";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../../reducers/AutomationReducer";
import {onClickDetails} from "../../../../services/AutomationServices";
import {getAccountInfo} from "../../../../utils/GenericUtils";
import {amber, purple} from "@mui/material/colors";
import clsx from "clsx";
import DoneOutlineTwoToneIcon from "@mui/icons-material/DoneOutlineTwoTone";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import PersonAddTwoToneIcon from '@mui/icons-material/PersonAddTwoTone';
import {useSessionStorage} from "../../../../utils/hooks/SessionStorageHook";

export const FocolaioContext = createContext();

const FocolaioDetailPage = () => {
	const classes = BaseStyle();
	let {id, idSoggetto} = useParams();
	let history = useHistory();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [selected, setSelected] = useState(idSoggetto ? idSoggetto : "");
	const [submitGetFocolaio, setSubmitGetFocolaio] = useState(false);
	const [submitUpdateFocolaio, setSubmitUpdateFocolaio] = useState(false);
	const [quarantenaSelected, setQuarantenaSelected] = useState({});
	const [openSave, setOpenSave] = useState(false);
	const [updateDiario, setUpdateDiario] = useState(0);
	const [backOk, setBackOk] = useState(false);
	const [openAlias, setOpenAlias] = useState(false);
	const [submitChangeAlias, setSubmitChangeAlias] = useState(false);
	const [backPos, setBackPos] = useSessionStorage("backPos", "/gestione/quarantene");

	const selectPaziente = useCallback((quarantena) => {
		setSelected(quarantena?.soggetto?.idSoggetto);
		setQuarantenaSelected(quarantena);
		history.push("/gestione/focolai/" + id + "/soggetto/" + quarantena.soggetto?.idSoggetto);
	}, [history, id]);

	const backFunction = () => {
		if (submitGetFocolaio && !quarantenaState.loadingGetFocolaio && quarantenaState.errorGetFocolaio === "") {
			setSubmitUpdateFocolaio(true);
			updateFocolaio(quarantenaState.focolaio, id, quarantenaDispatch);
		}
	}

	const changeAlias = useCallback(() => {
		let newAlias = document.getElementById("alias-focolaio")?.value;
		if (newAlias && newAlias.length > 4) {
			setSubmitChangeAlias(true);
			modifyAliasFocolaio(id, newAlias, quarantenaDispatch);
		}
	}, [id, quarantenaDispatch])

	useEffect(() => {
		if (submitChangeAlias && !quarantenaState.loadingModifyAlias && quarantenaState.errorModifyAlias === "") {
			setSubmitChangeAlias(false);
			setOpenAlias(false);
			setOpenSnackbar("success", "Alias modificato con successo", appContext.dispatch)
		} else if (submitChangeAlias && !quarantenaState.loadingModifyAlias && quarantenaState.errorModifyAlias !== "") {
			setSubmitChangeAlias(false);
			setOpenSnackbar("error", quarantenaState.errorModifyAlias, appContext.dispatch)
		}
	}, [submitChangeAlias, quarantenaState.loadingModifyAlias, quarantenaState.errorModifyAlias, appContext.dispatch])

	useEffect(() => {
		if (submitUpdateFocolaio && !quarantenaState.loadingUpdateFocolaio && quarantenaState.errorUpdateFocolaio === "") {
			setSubmitUpdateFocolaio(false);
			setBackOk(true);
			setOpenSnackbar("success", "Focolaio aggiornato con successo", appContext.dispatch);
			history.push(backPos);
		} else if (submitUpdateFocolaio && !quarantenaState.loadingUpdateFocolaio && quarantenaState.errorUpdateFocolaio !== "") {
			setSubmitUpdateFocolaio(false);
			setOpenSnackbar("error", quarantenaState.errorUpdateFocolaio, appContext.dispatch);
		}
	}, [submitUpdateFocolaio, quarantenaState.loadingUpdateFocolaio, quarantenaState.errorUpdateFocolaio, appContext.dispatch, history, backPos])

	useEffect(() => {
		setSubmitGetFocolaio(true);
		getFocolaioById(id, quarantenaDispatch);
	}, [id, quarantenaDispatch, idSoggetto])

	useEffect(() => {
		if (idSoggetto && quarantenaSelected.id) {
			getQuarantenaHistory(quarantenaSelected.id, quarantenaDispatch);
			getAllMonitoraggiByQuarantena(quarantenaSelected.id, quarantenaDispatch);
		}
	}, [idSoggetto, anagraficaContext.dispatch, quarantenaSelected.id])

	useEffect(() => {
		if (submitGetFocolaio && !quarantenaState.loadingGetFocolaio && quarantenaState.errorGetFocolaio === "") {
			let quarantena;
			quarantenaState.focolaio?.quarantene?.forEach(q => {
				if (q.soggetto?.idSoggetto?.toString() === idSoggetto?.toString()) {
					quarantena = q
				}
			})
			if (quarantena) {
				setSelected(idSoggetto);
				setQuarantenaSelected(quarantena);
			}
		}
	}, [submitGetFocolaio, quarantenaState.loadingGetFocolaio, quarantenaState.errorGetFocolaio, quarantenaState.focolaio.quarantene, idSoggetto])

	useEffect(() => {
		onClickDetails(id, "focolaio", "modify", automationDispatch);
	}, [id, automationDispatch]);

	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (!automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/azioni");
				setOpenSnackbar("warning", "Focolaio in gestione, prova con un altro!", appContext.dispatch);
			}
		}
	}, [automationState.loadingOnClick, history, automationState.errorOnClick, automationState.operatorOnClick, appContext.dispatch])

	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);

	return (
		<React.Fragment>
			<Backdrop open={selected === ""} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			<FocolaioContext.Provider value={{state: quarantenaState, dispatch: quarantenaDispatch}}>
				<main className={classes.main}>
					<HideAppBar title={
						<div style={{flexGrow: 1, display: "flex"}}>
							<Tooltip title={"Modifica nome dell'associazione"}>
								<Button variant={"text"} component={"h5"}
								        style={{textTransform: "initial", fontSize: 22, color: "#FFF", borderRadius: 24}}
								        onClick={() => setOpenAlias(true)}>
									<b>Associazione {id}</b>
									{
										quarantenaState.focolaio?.alias &&
										<span style={{
											paddingLeft: 10,
											paddingRight: 10,
											marginLeft: 18,
											borderRadius: 24,
											backgroundColor: "rgba(255,255,255,0.8)",
											color: "#000"
										}}><b>{quarantenaState.focolaio.alias}</b></span>
									}
								</Button>
							</Tooltip>
						</div>
					} back={true} backOk={backOk} useBackOk={true}
					            backFunction={backFunction}/>
					<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
						<Grid container spacing={3}>
							<Grid item xs={12} md={6}>
								<Grid container spacing={3} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
									{
										quarantenaState.loadingGetFocolaio ? <Skeleton/> :
											quarantenaState.errorGetFocolaio !== "" ? "Err ..." :
												quarantenaState.focolaio?.quarantene.map((quarantena) => {
													return (
														<Grid item xs={12} key={quarantena.id} style={{marginBottom: 0}}>
															<AnagraficaAccordion quarantena={quarantena} selectSoggetto={selectPaziente}/>
														</Grid>
													)
												})
									}
								</Grid>
							</Grid>
							<Grid item xs={12} md={6}>
								<Grid container spacing={3}
								      style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden", paddingBottom: 50}}>
									<Grid item xs={12}>
										{
											selected !== "" && <DiarioPaziente idSoggetto={idSoggetto} updateDiario={updateDiario}/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											selected !== "" && quarantenaSelected &&
											<QuarantenaInfoCard quarantena={quarantenaSelected}
											                    tipoQuarantena={quarantenaSelected?.tipo} setUpdateDiario={setUpdateDiario}/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											selected !== "" &&
											quarantenaState.loadingGetQuarantenaHistory ? <Skeleton/> :
												quarantenaState.errorGetQuarantenaHistory !== "" ?
													<Alert severity="error" style={{borderRadius: 24}}>
														<AlertTitle>Errore</AlertTitle>
														Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta
														gli sviluppatori.
													</Alert> :
													<HistoryCard storico={quarantenaState.quarantenaHistory} quarantena={quarantenaSelected}/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											selected !== "" && quarantenaSelected &&
											<MonitoraggiCard soggetto={idSoggetto} quarantena={quarantenaSelected}
											                 monitoraggi={quarantenaSelected.monitoraggi}/>
										}
									</Grid>
									<Grid item xs={12}>
										{
											selected !== "" &&
											<PrenotaTamponeCard idSoggetto={idSoggetto} setUpdateDiario={setUpdateDiario}
											                    idQuarantena={quarantenaSelected.id}/>
										}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Container>
				</main>

				<div className={classes.fabContainer}>
					<Fab
						variant={"extended"}
						type={"submit"}
						style={{
							backgroundColor: amber[500],
							color: "#000"
						}}
						className={clsx(classes.fab, classes.greenFab)}
						/*onClick={() => window.open("https://ocean.aslcittaditorino.it/gestione/intervistec/" + id, "_blank")}*/
						onClick={() => history.push("/gestione/intervistec/" + id)}
					>
						<PersonAddTwoToneIcon className={classes.extendedIconFab}/>
						Aggiungi contatto
					</Fab>
					<Fab
						variant={"extended"}
						type={"submit"}
						style={{
							backgroundColor: purple[500],
							color: "#FFF"
						}}
						className={clsx(classes.fab, classes.greenFab)}
						onClick={() => setOpenSave(true)}
					>
						<DoneOutlineTwoToneIcon className={classes.extendedIconFab}/>
						Salva
					</Fab>
				</div>
			</FocolaioContext.Provider>

			{
				openSave && <SimpleDialog open={openSave} handleClose={() => setOpenSave(!openSave)}
				                          title={"Confermi di voler salvare e tornare indietro?"} maxWidth={"md"}
				                          content={
					                          <React.Fragment>
						                          <DialogContentText>
							                          Cliccando su salva tornerai alla gestione complessiva dei focolai e ne potrai
							                          prendere in carico un altro.<br/>
							                          <b>Ricordati di segnare come IN CORSO o CONCLUSA</b> un'
							                          autosorveglianza/isolamento qualora questa/o lo sia.
						                          </DialogContentText>
						                          <Grid container spacing={2} style={{marginBottom: 20}}>
							                          <Grid item xs={12}>
								                          <FormControl variant={"outlined"} fullWidth={true}>
									                          <InputLabel htmlFor="grouped-native-select">Torna su</InputLabel>
									                          <Select
										                          label={"Torna su"}
										                          labelId="stato-label"
										                          id="grouped-native-select"
										                          value={backPos}
										                          onChange={(e) => {
											                          setBackPos(e.target.value)
										                          }}
									                          >
										                          <MenuItem value={"/gestione/quarantene"}>Autosorveglianze ed
											                          Isolamenti</MenuItem>
										                          <MenuItem value={"/gestione/scadenziario"}>Calendario autosorveglianze ed
											                          isolamenti</MenuItem>
										                          <MenuItem value={"/gestione/focolai"}>Gestione focolai</MenuItem>
									                          </Select>
								                          </FormControl>
							                          </Grid>
						                          </Grid>
					                          </React.Fragment>
				                          }
				                          actions={<DialogActions>
					                          <Button onClick={() => setOpenSave(!openSave)} style={{borderRadius: 24}}>
						                          <b>annulla</b>
					                          </Button>
					                          <Button onClick={backFunction} style={{borderRadius: 24, color: "#FFF"}}
					                                  color={"primary"}
					                                  variant={"contained"} disableElevation disabled={submitUpdateFocolaio}>
						                          <b>Salva</b>
					                          </Button>
				                          </DialogActions>}/>
			}

			{
				openAlias && <SimpleDialog open={openAlias} handleClose={() => setOpenAlias(!openAlias)}
				                           title={"Cambia il nome all'associazione"} maxWidth={"md"}
				                           content={<React.Fragment>
					                           <DialogContentText>
						                           Indica nel campo di testo qua sotto un nuovo alias per l'associazione. Questo può
						                           esserti di aiuto per riconoscere l'associazione in futuro.<br/>
						                           <b>NB: Non sei obbligato/a a modificarlo!</b>
					                           </DialogContentText>
					                           <Grid container spacing={3}>
						                           <Grid item xs={12}>
							                           <TextField variant={"outlined"} id={"alias-focolaio"}
							                                      label={"Alias focolaio"} fullWidth={true}
							                                      placeholder={"Inserisci un nuovo alias per il focolaio di almeno 4 caratteri"}/>
						                           </Grid>
					                           </Grid>
				                           </React.Fragment>}
				                           actions={<DialogActions>
					                           <Button onClick={() => setOpenAlias(!openAlias)} style={{borderRadius: 24}}>
						                           <b>Annulla</b>
					                           </Button>
					                           <Button onClick={() => changeAlias()} style={{borderRadius: 24, color: "#FFF"}}
					                                   color={"primary"} disabled={submitChangeAlias}
					                                   variant={"contained"} disableElevation>
						                           <b>Salva</b>
					                           </Button>
				                           </DialogActions>}/>
			}
		</React.Fragment>
	);
};

export default React.memo(FocolaioDetailPage);
